import * as React from 'react';
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu';
const { connect } = require('react-redux');
import { browserHistory } from 'react-router';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IStore } from 'redux/IStore';
import { IMenu, IMenuAction } from 'models/menu';
import {
	setSideMenuActiveKey,
	setSideMenuOpenKeys,
	setSideMenuSelectedKeys,
	clearSideMenuData,
} from 'redux/modules/menus/sidemenu';
require('./style.css');
import { IUserLanguage } from 'models/user/userlanguage';
import { ILanguage } from 'models/common';
import { updateIndex } from 'redux/modules/search/search';
import renderIcon from 'helpers/renderIcon';

interface IProps {
	routing?: any;
	sideMenu?: IMenu;
	t?: (key: string) => string;
	setSideMenuActiveKey?: (activeKey: string) => IMenuAction;
	setSideMenuOpenKeys?: (openKeys: string[]) => IMenuAction;
	setSideMenuSelectedKeys?: (selectedKeys: string[]) => IMenuAction;
	clearSideMenuData?: () => IMenuAction;
	updateIndex?: () => any;
	closeSideBarCallback: () => void;
	userLanguage?: IUserLanguage;
	languageDomainValues?: ILanguage[];
	accessToken?: string;
	sidebarOpen?: boolean;
}

interface IState {
	reindexed: boolean;
}

@connect(
	(state: IStore) => ({
		routing: state.routing,
		sideMenu: state.sideMenu,
		languageDomainValues: state.domainValues.languages,
		userLanguage: state.userLanguage,
		accessToken: state.fetchDefault.accessToken,
	}),
	(dispatch) => ({
		setSideMenuActiveKey: (activeKey: string) => dispatch(setSideMenuActiveKey(activeKey)),
		setSideMenuOpenKeys: (openKeys: string[]) => dispatch(setSideMenuOpenKeys(openKeys)),
		setSideMenuSelectedKeys: (selectedKeys: string[]) => dispatch(setSideMenuSelectedKeys(selectedKeys)),
		clearSideMenuData: () => dispatch(clearSideMenuData()),
		updateIndex: () => dispatch(updateIndex()),
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminSideMenu extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.handleOnOpenChange = this.handleOnOpenChange.bind(this);
		this.handleOnSelect = this.handleOnSelect.bind(this);
		this.handleIndexClick = this.handleIndexClick.bind(this);
		this.state = {
			reindexed: false,
		};
	}

	public componentDidMount() {
		this.handleMenuData(this.props);
	}

	public componentDidUpdate(prevProps: IProps) {
		if (
			this.props.routing.locationBeforeTransitions &&
			prevProps.sideMenu.selectedKeys.length > 0 &&
			this.props.routing.locationBeforeTransitions.pathname !== prevProps.sideMenu.selectedKeys[0]
		) {
			this.handleMenuData(this.props);
		}
	}

	public componentWillUnmount() {
		this.props.clearSideMenuData();
	}

	private handleIndexClick() {
		const { accessToken } = this.props;
		if (this.state.reindexed) {
			return;
		}
		if (!accessToken) {
			return alert('Unauthorized');
		}
		if (confirm('Update index?')) {
			this.setState({
				reindexed: true,
			});
			this.props.updateIndex();
		}
	}

	private handleOnClick(event: any) {
		browserHistory.push(event.key);
	}

	private handleOnOpenChange(openKeys: string[]) {
		this.props.setSideMenuOpenKeys(openKeys);
	}

	private handleOnSelect(data: any) {
		this.props.setSideMenuActiveKey(data.key);
		this.props.setSideMenuSelectedKeys(data.selectedKeys);
	}

	private handleMenuData(props: IProps) {
		const routing = props.routing;
		const openKeys = [];
		const selectedKeys = [];
		let activeKey = '';
		if (routing.locationBeforeTransitions) {
			openKeys.push(
				routing.locationBeforeTransitions.pathname.substr(
					0,
					routing.locationBeforeTransitions.pathname.lastIndexOf('/'),
				),
			);
			selectedKeys.push(routing.locationBeforeTransitions.pathname);
			activeKey = routing.locationBeforeTransitions.pathname;
			this.props.setSideMenuActiveKey(activeKey);
			this.props.setSideMenuOpenKeys(openKeys);
			this.props.setSideMenuSelectedKeys(selectedKeys);

			// open active submenus
			const splitActive = activeKey.split('/');
			let path = '/' + splitActive[1];
			for (let i = 2; i < splitActive.length - 1; i++) {
				path += '/' + splitActive[i];
				openKeys.push(`${path}`);
			}
		}

		if (this.props?.sidebarOpen) {
			this.props.closeSideBarCallback();
		}
	}
	public render() {
		const { t } = this.props;
		const { selectedKeys, openKeys, activeKey } = this.props.sideMenu;

		return (
			<div className="adminLeftSideMenu">
				<Menu
					mode="inline"
					onClick={this.handleOnClick}
					onSelect={this.handleOnSelect}
					onOpenChange={this.handleOnOpenChange}
					openKeys={openKeys}
					selectedKeys={selectedKeys}
					activeKey={activeKey}
					expandIcon={(props) => (
						<span className={`submenu-indicator ${props.isOpen ? 'isopen' : ''}`}>{renderIcon('submenu')}</span>
					)}
				>
					<SubMenu key="/admin/portal" title={t('BSPortal_Common_Portal')}>
						<SubMenu key="/admin/portal/pages" title={t('BSPortal_Common_Pages')}>
							<MenuItem key="/admin/portal/pages/all">{t('BSPortal_Common_All')}</MenuItem>
							<MenuItem key="/admin/portal/pages/active">{t('BSPortal_Common_Active')}</MenuItem>
							<MenuItem key="/admin/portal/pages/expired">{t('BSPortal_Common_Expired')}</MenuItem>
						</SubMenu>
						<MenuItem key="/admin/portal/menu">{t('BSPortal_Common_Menu')}</MenuItem>
					</SubMenu>

					<SubMenu key="/admin/magazine" title={t('BSPortal_Common_Magazine')}>
						<SubMenu key="/admin/magazine/pages" title={t('BSPortal_Common_Pages')}>
							<MenuItem key="/admin/magazine/pages/all">{t('BSPortal_Common_All')}</MenuItem>
							<MenuItem key="/admin/magazine/pages/active">{t('BSPortal_Common_Active')}</MenuItem>
							<MenuItem key="/admin/magazine/pages/expired">{t('BSPortal_Common_Expired')}</MenuItem>
						</SubMenu>
						<MenuItem key="/admin/magazine/menu">{t('BSPortal_Common_Menu')}</MenuItem>
					</SubMenu>
					<SubMenu title={t('Admin_LeftSideMenu_Articles')} key="/admin/articles">
						<MenuItem key="/admin/articles/allposts">{t('Admin_LeftSideMenu_Articles_AllPosts')}</MenuItem>
						<MenuItem key="/admin/articles/approved">{t('Admin_LeftSideMenu_Articles_Approved')}</MenuItem>
						<MenuItem key="/admin/articles/pending">{t('Admin_LeftSideMenu_Articles_Pending')}</MenuItem>
						<MenuItem key="/admin/articles/drafts">{t('Admin_LeftSideMenu_Articles_Drafts')}</MenuItem>
						<MenuItem key="/admin/articles/unlisted">{t('Admin_LeftSideMenu_Articles_Unlisted')}</MenuItem>
					</SubMenu>
					<SubMenu title={t('Admin_LeftSideMenu_Shops')} key="/admin/shops">
						<MenuItem key="/admin/shops/allshops">{t('Admin_LeftSideMenu_Shops_AllShops')}</MenuItem>
						<MenuItem key="/admin/shops/approved">{t('Admin_LeftSideMenu_Shops_Approved')}</MenuItem>
						<MenuItem key="/admin/shops/pending">{t('Admin_LeftSideMenu_Shops_Pending')}</MenuItem>
					</SubMenu>
					<MenuItem key="/admin/tags">{t('Admin_LeftSideMenu_Tags')}</MenuItem>
					<MenuItem key="/admin/polls">{t('Admin_LeftSideMenu_Polls')}</MenuItem>
					<MenuItem key="/admin/shopreviews">{t('Admin_LeftSideMenu_ShopReviews')}</MenuItem>
					<MenuItem key="/admin/subscriptionplans">{t('Admin_LeftSideMenu_SubscriptionPlans')}</MenuItem>
					<br />
					<MenuItem key="/admin/serverlog">Server Log</MenuItem>
					{this.state.reindexed ? null : (
						<li className="rc-menu-item" onClick={this.handleIndexClick} style={{ paddingLeft: '24px' }}>
							Update index
						</li>
					)}
				</Menu>
			</div>
		);
	}
}

export { AdminSideMenu };
